export const FEEDBACK_MODAL_EVENT = 'trafficlite-open-feedback-modal';

export type FeedbackModalStep = 'main' | 'issue' | 'feature';
export type FeedbackModalSource = 'manual' | 'auto';

interface FeedbackModalOpenOptions {
  initialStep?: FeedbackModalStep;
  returnToRoute?: string;
  source?: FeedbackModalSource;
}

export const openFeedbackModal = (options?: FeedbackModalOpenOptions) => {
  window.dispatchEvent(new CustomEvent(FEEDBACK_MODAL_EVENT, { detail: options || {} }));
};
